import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL;

const api = axios.create({
  baseURL,
});

api.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem('authToken');
    
    // Skip adding auth for login endpoints
    const skipAuthUrls = ['/auth/getotp/', '/auth/validateotp/'];
    const shouldSkipAuth = skipAuthUrls.some(url => config.url && config.url.includes(url));
    
    if (authToken && !shouldSkipAuth) {
      if (config.url && config.url.includes('?')) {
        config.url += `&authToken=${authToken}`;
      } else {
        config.url += `?authToken=${authToken}`;
      }
      
      config.headers = {
        ...config.headers,
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      };
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;